// Espelha OrigemLoteSerieEstoqueEnum da API.Produto: de onde vieram o lote e a série de uma linha da prévia do estoque
// do pedido (do item, da reserva do documento ou da sugestão pelo lote que vence primeiro).
export enum OrigemLoteSerieEstoqueEnum {
    Item = 1,
    Reserva = 2,
    Sugestao = 3,
}
